import styled, { css } from 'styled-components';
import { Grey, Grey1, White } from '../../styles/colours';
import { Medium } from '../../styles/fonts';

export const Table = styled.table`
  border-bottom: none;
  border-collapse: collapse;
  width: 100%;

  tr:last-child td {
    border-bottom: 0;
  }

  tr:hover td {
    background: ${Grey1};
  }
`;

interface IAlignment {
  align?: 'left' | 'right' | 'center';
}
export const TD = styled.td<IAlignment>`
  border-bottom: 1px solid ${Grey};
  padding: 2rem;
  vertical-align: top;
  white-space: nowrap;
  ${props =>
    props.align &&
    css`
      text-align: ${props.align};
    `}
`;

export const IconTableCell = styled.td`
  border-bottom: 1px solid ${Grey};
  padding: 2rem 0rem 0rem 2rem;
  vertical-align: top;
  white-space: nowrap;
`;

export const TH = styled.th<IAlignment>`
  font-family: ${Medium};
  border-bottom: 1px solid ${Grey};
  padding: 2rem 1rem 1rem 2rem;
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: ${White};
  ${props =>
    props.align &&
    css`
      text-align: ${props.align};
    `}
`;
